import React from 'react';
import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';

export type TimeRange = '1h' | '6h' | '24h' | '7d' | 'all';

interface TimeRangeSelectorProps {
    value: TimeRange;
    onChange: (value: TimeRange) => void;
    size?: 'small' | 'medium' | 'large';
    showAll?: boolean;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
    value,
    onChange,
    size = 'small',
    showAll = true,
}) => {
    const handleChange = (
        _event: React.MouseEvent<HTMLElement>,
        newValue: TimeRange | null,
    ) => {
        if (newValue !== null) {
            onChange(newValue);
        }
    };

    return (
        <Box>
            <ToggleButtonGroup
                value={value}
                exclusive
                onChange={handleChange}
                aria-label="time range"
                size={size}
                sx={{
                    '& .MuiToggleButtonGroup-grouped': {
                        margin: 0.5,
                        border: 1,
                        borderColor: 'divider',
                        '&.Mui-selected': {
                            fontWeight: 'bold',
                        },
                    },
                }}
            >
                <ToggleButton value="1h" aria-label="1 hour">
                    1h
                </ToggleButton>
                <ToggleButton value="6h" aria-label="6 hours">
                    6h
                </ToggleButton>
                <ToggleButton value="24h" aria-label="24 hours">
                    24h
                </ToggleButton>
                <ToggleButton value="7d" aria-label="7 days">
                    7d
                </ToggleButton>
                {showAll && (
                    <ToggleButton value="all" aria-label="all time">
                        All
                    </ToggleButton>
                )}
            </ToggleButtonGroup>
        </Box>
    );
};

export default TimeRangeSelector; 